@if (icon()) {
  <custom-icon [name]="icon()!" [size]="iconSize()" [viewBox]="iconViewBox()" [color]="iconColor()" />
}

<span class="chip-label">{{ text() }}</span>

<button type="button" class="remove-btn" aria-label="remove" (click)="onRemove($event)">
  <lucide-icon [name]="closeIcon" size="12"></lucide-icon>
</button>
